module.exports = __webpack_public_path__ + "static/media/choon_Screen2.476a2087.png";